"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = assert;

var _AssertionError = _interopRequireDefault(require("./AssertionError.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/asserts
 */

/**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {number} errorCode Error code.
 */
function assert(assertion, errorCode) {
  if (!assertion) {
    throw new _AssertionError["default"](errorCode);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOzs7O0FBSEE7Ozs7QUFLQTs7OztBQUlNLFNBQVVBLE1BQVYsQ0FBaUJDLFNBQWpCLEVBQTRCQyxTQUE1QixFQUFxQztFQUN6QyxJQUFJLENBQUNELFNBQUwsRUFBZ0I7SUFDZCxNQUFNLElBQUlFLDBCQUFKLENBQW1CRCxTQUFuQixDQUFOO0VBQ0Q7QUFDRiIsIm5hbWVzIjpbImFzc2VydCIsImFzc2VydGlvbiIsImVycm9yQ29kZSIsIkFzc2VydGlvbkVycm9yIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9hc3NlcnRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19